let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hwLuK")).then(() => parcelRequire('8ehFz'));